import * as XLSX from "xlsx";
export default function useExportExcel() {


  const generateFile = async (raw_data, columnName, fileName, tableName, startRow) => {
    try {
      let arrayObjectData = [];

      raw_data.forEach(data => {
        let row = {};
        columnName.forEach(colName => {
          if (colName.field !== "error") {
            row[colName.name] = data[colName.field];
          } else if (colName.field === "error" && data[colName.field].length > 0) {
            let errorArray = data[colName.field];
            row[colName.name] = getErrorLang(errorArray, tableName, columnName);
          }
        })
        // console.log(row);
        arrayObjectData.push(row);
      })
      // console.log(arrayObjectData);
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(arrayObjectData, { origin: startRow - 2 });

      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      /* calculate column widths */
      const columnWidths = arrayObjectData.reduce((acc, row) => {
        Object.keys(row).forEach(key => {
          const cellLength = String(row[key]).length;
          acc[key] = Math.max(acc[key] || 0, cellLength);
        });
        return acc;
      }, {});

      /* set column widths in the worksheet */
      worksheet['!cols'] = [];
      Object.keys(columnWidths).forEach(column => {
        const width = columnWidths[column];
        worksheet['!cols'].push({ wch: width });
      });

      XLSX.writeFile(workbook, `${fileName}.xlsx`, { compression: true, bookSST: true });
    } catch (error) {
      console.error("Error generating file:", error);
    }
  };

  const getErrorLang = (value, tableName, columnName) => {
    let errorType = ""
    let validateBlank = "':field' ห้ามเป็นค่าว่าง";
    let validateDuplicateInFile = "':field' ห้ามซ้ำใน file";
    let validateDuplicateInDatabase = "':field' ซ้ำกับในระบบ";
    let validateLength = "':field' ระบุความยาวไม่เกิน :length ตัวอักษร";
    let validateDataNotFound = "':field' ไม่พบข้อมูล";
    let validateDateFormat = "':field' รูปแบบวันที่นำเข้าไม่ถูกต้อง 'DD/MM/YYYY (พ.ศ.)'";
    let validateDecimalFormat = "':field' รูปแบบตัวเลขทศนิยมนำเข้าไม่ถูกต้อง '###.##'";  

    value.forEach((item, index) => {
      let field = columnName.find(c => c.field === item.field);
      switch (item.type) {
        case "blank":
          errorType += validateBlank.replace(":field", field.name);
          break;
        case "duplicate":
          errorType += validateDuplicateInFile.replace(":field", field.name);
          break;
        case "duplicateInDatabase":
          errorType += validateDuplicateInDatabase.replace(":field", field.name).replace(":table", tableName);
          break;
        case "overflow":
          errorType += validateLength.replace(":field", field.name).replace(":length", item.wordLength);
          break;
        case "doNotExist":
          errorType += validateDataNotFound.replace(":field", field.name);
          break;
        case "invalid":
          errorType += validateType.replace(":field", field.name);
          break;
        case "invalidDecimal":
          errorType += validateDecimalFormat.replace(":field", field.name);
          break;
        case "format":
          errorType += validateDateFormat.replace(":field", field.name);
          break;
      }
      if (index < value.length - 1) {
        errorType += "\r\n";
      }
    })
    return errorType;
  }

  return {
    generateFile,
    getErrorLang
  };
}